import { XStack, View, Text } from "tamagui";
import { colors } from "@styles/colors";
import { Account } from "./couponData";

interface AccGroupLabelProps {
  acc: Account;
  count: number;
}

export const AccountGroupLabel = ({ acc, count }: AccGroupLabelProps) => {
  const isShared = (acc.members?.length || 0) > 1;

  return (
    <XStack ai="center" gap="$2" mb="$2" px="$1">
      <View w={6} h={6} br={3} bg={acc.color} flexShrink={0} />
      <Text fontSize={12} fow="700" color={acc.color}>
        {acc.label}
      </Text>
      {isShared && (
        <View bg={`${acc.color}15`} px="$1.5" py="$0.5" br={6}>
          <Text fontSize={9} fow="700" color={acc.color}>
            共享
          </Text>
        </View>
      )}
      <Text fontSize={10} color={colors.gray} ml="auto">
        {count} 張
      </Text>
    </XStack>
  );
};
